// pkg
export const WORDPRESS = "Wordpress";
